import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
i18n.use(resourcesToBackend((language, namespace, callback) => {
  import(`./${window.np.getLocale()}-translations.js`)
    .then(({default: resources}) => {
      callback(null, resources)
    })
    .catch((error) => {
      callback(error, null)
    })
})).use(initReactI18next).init({
  lng: 'en-IE',
  fallbackLng: 'en-IE',
  interpolation: { escapeValue: true }
});
export default i18n;